module.exports = __webpack_public_path__ + "static/media/ranger4wd2015.342cc373.jpg";